export default "__VITE_ASSET__3Y9cE2DA__"